export function Meter({ used, total }: { used: number; total: number }) {
  const pct = total > 0 ? Math.min(100, Math.round((used / total) * 100)) : 0;
  const over = used > total;
  return (
    <div className="meter">
      <i className={over ? "over" : ""} style={{ width: `${pct}%` }} />
    </div>
  );
}
